import { ResourceCountries } from '@/core/domain/resource-countries/models/resource-countries.model';
import { ResourceCountriesRepository } from '@/core/domain/resource-countries/repositories/resource-countries.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ResourceCountriesImplRepository extends ResourceCountriesRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getResourceCountries(): Observable<ResourceCountries> {
        return this.httpClient
            .get(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.resourceCountries,
                ].join('/'),
            )
            .pipe(
                switchMap((response: ResourceCountries) => {
                    const resourceCountries: ResourceCountries = {
                        type: response.type,
                        action: response.action,
                        notifications: response.notifications,
                        data: response.data,
                    };

                    return of(resourceCountries);
                }),
            );
    }
}
